"use client"

import {SelectInput, useField, useLocale, useTranslation} from "@payloadcms/ui";
import {useEffect, useState} from "react";
import {getProductFamiliesWithGroups} from "@/api/actions/families";
import {Option, OptionObject} from "payload";

export function GroupField({ path }: { path: string }) {
    const { value, setValue } = useField<string[]>({ path });
    const [options, setOptions] = useState<OptionObject[]>([]);

    const locale = useTranslation();

    useEffect(() => {
        const fetchOptions = async () => {
            const options = await getProductFamiliesWithGroups(locale.i18n.language, "DE", "metric", "internal");
            if(options.data) {
                setOptions(options.data.flatMap(family => family.Groups).map(group => ({
                    label: String(group?.Name),
                    value: String(group?.ID)
                })));
            }
        }

        fetchOptions();
    }, [])

    return (
        <div>
            <label className="field-label">
                Select - Produktgruppe(n)
            </label>
            <SelectInput
                name={path}
                path={path}
                value={typeof value === "string" ? (JSON.parse(value) as string[]).map(val => {
                    const optionVal = options.find(option => option.value === val);
                    return optionVal ? String(optionVal?.value) : val;
                }) : value}
                options={options}
                onChange={(e) => {
                    // @ts-ignore
                    setValue((e as Option[]).map(item => String(item.value)))
                }}
                hasMany={true}
            />
        </div>
    )
}